import React, { useEffect } from "react";
import { Control, useController } from "react-hook-form";
import useFetchChoices from "../../choices/useFetchChoices";
import { FormComponent } from "./FormComponent";
import Select from "../../../admin/common/Select";
import { DropdownChoicesType } from "../../../admin/types/common";

interface SelectFieldProps {
	control: Control;
	choicesEndpoint?: string;
	defaultValue?: string | number;
	dropdownItems?: DropdownChoicesType;
	disabled?: boolean;
	id?: string;
	inputParser?: (value: string) => void;
	label?: string;
	name: string;
	placeholder?: string;
	required?: boolean;
	setValue?: (key: string, value: number | string) => void;
}

export function SelectField({
	choicesEndpoint,
	control,
	defaultValue,
	dropdownItems,
	disabled,
	id,
	inputParser,
	label,
	name,
	placeholder,
	required = false,
	setValue,
}: SelectFieldProps) {
	const { choices, loading } = useFetchChoices(
		`/api/v1/choices/${choicesEndpoint}`,
		undefined,
		!dropdownItems,
	);

	const {
		field: { value, onChange },
		formState: { errors },
	} = useController({
		name,
		control,
		rules: {
			required,
		},
		defaultValue,
	});

	useEffect(() => {
		if (dropdownItems && setValue) {
			setValue(name, dropdownItems[0].key);
		}
	}, [dropdownItems]);

	const component = {
		id: id || name,
		name,
		label,
		required,
		errors,
	};

	return (
		<FormComponent {...component}>
			<Select
				choices={dropdownItems || choices}
				currentValue={value || ""}
				disabled={disabled}
				emptyValue={loading ? "Loading..." : placeholder}
				onInputChange={(name: string, value: string) =>
					onChange(inputParser ? inputParser(value) : value)
				}
				name={name}
				required={required}
			/>
		</FormComponent>
	);
}
